import { motion } from "framer-motion";

const LINKS = [
  { label: "ABOUT", href: "#about" },
  { label: "SPOOKYNOMICS", href: "#tokenomics" },
  { label: "SUMMON", href: "#how-to-buy" },
  { label: "CULT", href: "#community" },
];

export const Nav = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#080808]/80 border-b border-[#A020F0]/30"
    data-testid="main-nav"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo-link">
        <img
          src="/mascot.jpg"
          alt="$HALLOWIN logo"
          className="w-10 h-10 rounded-full ring-2 ring-[#FF6B00]/70 group-hover:ring-[#B6FF00] transition-all duration-300 group-hover:rotate-6"
        />
        <span className="font-display font-bold tracking-widest text-sm sm:text-base text-white group-hover:text-[#B6FF00] transition-colors">
          $HALLOWIN
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-7 mono text-xs tracking-[0.2em] text-purple-200/70">
        {LINKS.map((l) => (
          <a
            key={l.label}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className="hover:text-[#B6FF00] hover:glow-green transition-all duration-200"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href="#buy"
        data-testid="nav-buy-button"
        className="bg-[#B6FF00] text-black font-display font-bold uppercase text-xs sm:text-sm tracking-wider px-5 py-2.5 rounded-full shadow-[0_0_18px_rgba(182,255,0,0.5)] hover:scale-105 hover:shadow-[0_0_32px_rgba(182,255,0,0.85)] transition-all duration-200"
      >
        BUY NOW
      </a>
    </div>
  </motion.header>
);
